import gql from "graphql-tag";
import React from "react";
import { Query } from "react-apollo";
import Select from "react-select";
import useDebounce from "../../../lib/hooks/useDebounce";
import { SelectOnChangeHandlerFn, Option } from "./SelectController";

const adminSearchModels = gql`
  query adminSearchModels(
    $dataset: String
    $searchKeyword: String
    $offset: Int
  ) {
    models: adminSearchModels(
      dataset: $dataset
      searchKeyword: $searchKeyword
      offset: $offset
    ) {
      id
      name: displayName
    }
  }
`;

interface Model {
  id: string;
  name: string;
}

interface adminSearchModelsResult {
  models: Model[];
}

interface adminSearchModelsQueryVariables {
  dataset?: string;
  searchKeyword: string;
  offset?: number;
}

interface DrillDownSelectProps {
  onChange?: SelectOnChangeHandlerFn;
  value?: Option;
}

export const DrillDownSelect = (props: DrillDownSelectProps) => {
  const {
    onChange = () => {
      /* noop */
    },
    value,
  } = props;

  const {
    value: searchKeyword,
    deferredValue: deferredKeyword,
    setValue: setKeyword,
  } = useDebounce(250);

  return (
    <Query<adminSearchModelsResult, adminSearchModelsQueryVariables>
      variables={{
        offset: 0,
        dataset: "DRILLDOWN",
        searchKeyword: deferredKeyword,
      }}
      query={adminSearchModels}
    >
      {({ data, loading, error, fetchMore }) => {
        if (error) return <p>Error: {error.message}</p>;

        const options =
          data?.models?.map((model) => ({
            value: model.id,
            label: model.name,
          })) || [];

        return (
          <Select
            isClearable
            onChange={onChange}
            value={value}
            isLoading={loading}
            inputValue={searchKeyword}
            onInputChange={(value) => setKeyword(value)}
            options={options}
            placeholder="Select a Drill Down..."
            menuPortalTarget={document.querySelector("body")}
            onMenuScrollToBottom={() => {
              fetchMore({
                variables: {
                  offset: options.length,
                },
                updateQuery: (prev, { fetchMoreResult }) => {
                  if (!fetchMoreResult) return prev;

                  return {
                    models: [...prev.models, ...fetchMoreResult.models],
                  };
                },
              });
            }}
          />
        );
      }}
    </Query>
  );
};
